import React from "react";

import "./CreatedGameConfirmation.css";
import { useNavigate } from "react-router-dom";

const CreatedGameConfirmation = (props) => {
  const { createdPuzzle, onDismissConfirmation } = props;
  const navigate = useNavigate();
  return (
    <div className="created-game-confirmation-container">
      <h1>Game Created Successfully!</h1>
      <p>Your game has been created and is ready to play.</p>
      {/* <h2>{createdPuzzle?.id}</h2> */}
      <div
        className="return-to-dashboard-button"
        onClick={onDismissConfirmation}
      >
        Back to Dashboard
      </div>
    </div>
  );
};

export default CreatedGameConfirmation;
